import script from "./Home.vue?vue&type=script&setup=true&lang=ts"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=2a711e28&lang=scss&scoped=true"
import "./Home.vue?vue&type=style&index=1&id=2a711e28&lang=css"

import exportComponent from "C:\\Users\\konstantinos\\Desktop\\vouliagmeni\\threesixty_vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a711e28"]])

export default __exports__